import { cn } from '@/lib/utils'

interface LoaderSquaresProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number
}

const layerClassName = cn(
  'animate-loader-squares w-full min-h-0',
  '[--loader-gradient:linear-gradient(var(--loader-color),var(--loader-color))]',
  '[background-image:var(--loader-gradient),var(--loader-gradient)]',
  '[background-size:25%_50%]',
  '[background-repeat:no-repeat]'
)

/** Squares loader — animated via `loader-squares` keyframes in tailwind.config.js */
export const LoaderSquares = ({ size = 80, className, style, ...props }: LoaderSquaresProps) => (
  <div
    role="status"
    aria-label="Loading"
    className={cn('grid aspect-square grid-rows-2 [--loader-color:hsla(var(--foreground)/0.13)]', className)}
    style={{ height: size, ...style }}
    {...props}
  >
    <div className={layerClassName} />
    <div className={cn(layerClassName, 'scale-[-1]')} />
  </div>
)
